import { type FC, type PropsWithChildren } from 'react';
import cn from 'classnames';
import { type HTMLMotionProps, motion } from 'framer-motion';

import {
  H1Motion,
  StringSmallMotion,
} from '@/components/Typography/Typography';

interface ContractRewardMotionProps extends PropsWithChildren {
  classNames?: {
    title?: string;
    description?: string;
    wrapper?: string;
  };
  title: string | number;
  extraText?: string;
  description: string;
  motionProps: Partial<Omit<HTMLMotionProps<'div'>, 'children'>>;
}

const ContractRewardMotion: FC<ContractRewardMotionProps> = ({
  classNames,
  children,
  title,
  extraText,
  description,
  motionProps,
}) => {
  return (
    <motion.div
      {...motionProps}
      className={cn('flex flex-col items-center gap-1', classNames?.wrapper)}
    >
      {children}
      <div className="flex gap-0.5 items-center">
        <H1Motion weight="bold" className={classNames?.title}>
          {title}
        </H1Motion>
        {extraText && (
          <H1Motion
            weight="bold"
            className={cn(classNames?.title, 'text-yellow-400 !text-[1rem]')}
          >{`+${extraText}`}</H1Motion>
        )}
      </div>
      <StringSmallMotion
        weight="bold"
        className={cn('!text-white/40', classNames?.description)}
      >
        {description}
      </StringSmallMotion>
    </motion.div>
  );
};

export { ContractRewardMotion };
